var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Tippy from "@tippyjs/react/headless";
import { motion, useSpring } from "framer-motion";
import styled from "@emotion/styled";
import { colors } from "../theme";
export function Tooltip(_a) {
    var { children, content, maxWidth, placement = "bottom", hasPaddingInContent = true } = _a, props = __rest(_a, ["children", "content", "maxWidth", "placement", "hasPaddingInContent"]);
    const opacity = useSpring(0, { stiffness: 200 });
    function onMount() {
        opacity.set(1);
    }
    function onHide() {
        opacity.set(0);
    }
    return (_jsx(Tippy, Object.assign({ render: attrs => (_jsx(Container, Object.assign({ style: Object.assign({ opacity,
                maxWidth }, (!hasPaddingInContent && { padding: 0 })) }, attrs, { children: content }), void 0)), offset: [0, 8], animation: true, onMount: onMount, onHide: onHide, hideOnClick: false, placement: placement }, props, { children: children }), void 0));
}
const Container = styled(motion.div)(() => ({
    backgroundColor: colors.white,
    borderColor: colors.greyMainLight,
    borderRadius: 2,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: "0 2px 5px 0 hsla(0, 0%, 0%, 0.2)",
    color: colors.greyDark,
    fontFamily: "Open Sans, sans-serif",
    fontSize: "1.4rem",
    padding: "0.8rem 1.2rem",
}));
//# sourceMappingURL=Tooltip.js.map